<template>
  <div id="app">
    <Header />

    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
      "
    >
      <img
        src="@/assets/logo1.png"
        alt=""
        style="width: 16%; margin-right: 100px"
      />
      <div style="display: flex; flex-wrap: nowrap; font-weight: bold">
        <router-link
          v-for="route in navRoutes"
          :key="route.path"
          :to="route.path"
          class="nav-item"
          active-class="nav-active"
          :exact="route.path === '/'"
        >
          {{ $t(route.meta.titleKey) }}
        </router-link>
      </div>
    </div>

    <div class="main-content">
      <router-view />
    </div>

    <Links />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Links from "./components/Links.vue";
export default {
  name: "App",
  components: {
    Header,
    Links,
  },
  computed: {
    navRoutes() {
      return this.$router.options.routes.filter((route) => {
        return route.meta && route.meta.showInNav === true;
      });
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

.nav-item {
  color: #333;
  text-decoration: none;
  font-size: 14px;
  padding: 5px 10px;
  margin: 0 20px;
  transition: color 0.2s;
  white-space: nowrap;
}

.nav-active {
  color: #c6a658;
  border-bottom: 2px solid #c6a658;
}
.main-content {
  flex: 1; /* ⭐核心 */
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: inherit;
}
</style>
